"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var styled_components_1 = require("styled-components");

var styles_1 = require("../../styles");

var types_1 = require("./types");

var styles_2 = require("./styles");

var Button = styles_1.styledWithProps('button', ['size', 'align', 'variant', 'responsive'], styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\t", ";\n\t"], ["\n\t\t", ";\n\t"])), styles_2.buttonStyle));
Button.defaultProps = {
  size: types_1.Size.NORMAL,
  align: types_1.Align.CENTER,
  variant: types_1.Variant.CALL_TO_ACTION
};
exports.default = Button;

tslib_1.__exportStar(require("./types"), exports);

var templateObject_1;